import React, { useEffect } from "react";

import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import ProfileSection from "../components/ProfileSection";
import Address from "../components/Address";
import OrdersTab from "../components/Orders";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      navigate("/login");
    }
  }, [navigate]); // Only run this effect when `navigate` changes

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />
      {/* Preloader */}
      <Preloader />
      {/* HeaderOne */}
      <HeaderOne category={true} />
      {/* Breadcrumb */}
      <Breadcrumb title={"My Profile"} />

      {/* Tabs for Profile, Address, and Orders */}
      <div style={{ padding: "24px", display: "flex" }}>
        <Tabs
          defaultActiveKey="1"
          tabPosition="left" // Vertical tabs
          style={{
            width: "100%",
          }}
          tabBarStyle={{
            fontSize: "18px", // Larger font size for tab titles
            fontWeight: "bold",
          }}
        >
          <Tabs.TabPane tab="Profile" key="1">
            <ProfileSection />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Address" key="2">
            <Address />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Orders" key="3">
            <OrdersTab />
          </Tabs.TabPane>
        </Tabs>
      </div>

      {/* FooterTwo */}
      <FooterOne />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProfilePage;
